import { View } from "react-native";
import React from "react";
import { useAppSelector } from "hooks/useAppSelector";
import { RouteProp, useRoute } from "@react-navigation/native";
import { RootStackParamList } from "navigation/types";
import MainContainer from "components/MainContainer";
import EventBanner from "components/EventBanner";
import { Text } from "@ui-kitten/components";
import StepTwo from "./StepTwo";
import { useFetchEventByCodeQuery } from "queries/event.queries";
import { toDashboard } from "utils/navigationUtils";
import LoginOrSignupForm from "components/LoginOrSignupForm";
import { formatEventDate } from "utils/eventUtils";

const ClaimGuestPasses = () => {
  const storedUserId = useAppSelector((state) => state.auth.id);
  const route = useRoute<RouteProp<RootStackParamList, "ClaimGuestPasses">>();
  const { eventCode, transferCode } = route.params;
  const { data: event } = useFetchEventByCodeQuery(eventCode);
  const type = route.name === "ClaimGuestPasses" ? "guest" : "voucher";

  if (!event) {
    return null;
  }

  return (
    <MainContainer
      title={type === "guest" ? "Claim Guest Passes" : "Claim Vouchers"}
      grayBackground
      goBackAction={toDashboard}
    >
      <View style={{ padding: 15 }}>
        {event !== null && (
          <View>
            <EventBanner event={event} />
            <Text category="h6" style={{ marginTop: 15 }}>
              You have been invited to the following event: {event.name}
            </Text>
            <Text category="c2" style={{ marginTop: 5 }}>
              Local Date: {formatEventDate(event)}
            </Text>
          </View>
        )}

        {/* if token is empty, show step one  */}
        {storedUserId === undefined && (
          <View style={{ marginVertical: 15 }}>
            <LoginOrSignupForm
              loginTitle="Must log in to view invite details"
              signupTitle="Create an account to claim your seat"
              marketplace
            />
          </View>
        )}

        {storedUserId !== undefined && (
          <View>
            <StepTwo
              transferCode={transferCode}
              eventCode={eventCode}
              type={type}
            />
          </View>
        )}
      </View>
    </MainContainer>
  );
};

export default ClaimGuestPasses;
